// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"e7fa1c2e","357":"732e4f80","455":"868abfbd","620":"6dbc9181","644":"c71d32b4","706":"ce372b9e","770":"579408b1","955":"00d7c3f1"}[chunkId] + ".chunk.js";
};